import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  runTransaction,
  where,
  documentId,
} from 'firebase/firestore';

import { firestore } from '../Firebase';
import { ColoringGridDTO } from '../../types/DTO/ColoringGridDTO';

export const setColoringGridData = async (data: ColoringGridDTO) => {
  const coloringGridsRef = collection(firestore, 'coloringGrids');
  const coloringGridId = data.id;

  await runTransaction(firestore, async (transaction) => {
    transaction.set(doc(coloringGridsRef, coloringGridId), data, { merge: true });
  });
};

export const getColoringGridById = async (id: string): Promise<ColoringGridDTO | null> => {
  const docRef = doc(firestore, 'coloringGrids', id);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists) {
    return null;
  }

  const coloringGridData = docSnap.data();

  const collectionsRef = query(
    collection(firestore, 'coloringGridCollections'),
    where(documentId(), 'in', coloringGridData?.collections || []),
  );

  const assignedCollections = await getDocs(collectionsRef);

  return {
    id: docSnap.id,
    ...coloringGridData,
    collections: assignedCollections.docs.map((col) => ({
      label: col.data().name,
      value: col.id,
    })),
  } as any as ColoringGridDTO;
};
